import api from "@/api";
import CONSTANTS from "@/store/constants";
import { mapGetters, mapMutations } from "vuex"

export default {
    data() {
        return {
            isStatusFetched: false,
            ONBOARDING_STATUS_MAP: {
                NA_RESELLER :'N/A - Reseller',
                NA_PAYMENT_CORPORATE_CARD :"N/A - Payment via Corporate Card",
                NA_ZERO_DOLLAR_ENGAGEMENT: "N/A - $0 Engagement",
                INVITE_SENT: 'Invite sent - pending supplier registration',
                EXISTING_SUPPLIER: 'Existing supplier',
                APPROVED: 'Approved',
                NOT_APPLICABLE: 'N/A'
            },
            onBoardingStatusTooltip: CONSTANTS.SUPPLIER_ONBOARDING_TRACKER.TOOLTIP,
            apexStatusTooltip: CONSTANTS.SUPPLIER_ONBOARDING_TRACKER.APEX_TOOLTIP
        }
    },
    computed: {
        ...mapGetters(["onBoardingCompletedRequests","supplierOnBoardingStatus","onBoardingPendingRequests"]),
    },
    methods: {
        ...mapMutations(["setSupplierOnBoardingStatus"]),
        async fetchSupplierOnBoardingStatus() {
            this.isStatusFetched = false
            this.fetchVendorOnBoardingStatus()
            await this.fetchCoreCompanyStatus()
            this.isStatusFetched = true
        },
        fetchVendorOnBoardingStatus() {
            this.onBoardingCompletedRequests.forEach((request) => {
                const isObjectPresent = this.supplierOnBoardingStatus.some(obj => obj.caseNumber === request.caseNumber);
                if(request.existingSupplier && !isObjectPresent) {
                    this.supplierOnBoardingStatus.push({
                        caseNumber: request.caseNumber,
                        status: this.ONBOARDING_STATUS_MAP.EXISTING_SUPPLIER,
                        vendorId: ''
                    })
                }
            })
        },
        async fetchCoreCompanyStatus() {
            let RITMList = this.formatRITMQuery(this.onBoardingCompletedRequests.map((item) => { return item.caseNumber }));
            try {
                const resp = await api.getCoreCompanyStatus(RITMList.toString())
                if(resp && resp.data && resp.data.result && resp.data.result.length > 0) {
                    const caseNumberToVendorIdsMap = new Map();

                    resp.data.result.forEach((obj) => {
                        const caseNumbers = obj.u_supplier_central_ritm.split(',').filter(Boolean); // Splitting the comma-separated case numbers
                        for (const caseNumber of caseNumbers) {
                            if (!caseNumberToVendorIdsMap.has(caseNumber)) {
                                caseNumberToVendorIdsMap.set(caseNumber, new Set());
                            }
                            caseNumberToVendorIdsMap.get(caseNumber).add(obj.u_vendor_id);
                        }
                    })
                    // Update the supplierOnBoardingStatus with the collected vendorIds
                    this.supplierOnBoardingStatus.forEach((item) => {
                        if (caseNumberToVendorIdsMap.has(item.caseNumber)) {
                            item.vendorId = [...caseNumberToVendorIdsMap.get(item.caseNumber)].join(',');
                        }
                    })
                }
            } catch {
                this.$hhMixpanel.trackEvent(CONSTANTS.MIXPANEL_API_FAILURE.SERVICE_NOW_CORE_COMPANY_API_FAILURE);
            } finally {
                this.setSupplierOnBoardingStatus(this.supplierOnBoardingStatus)
            }
        },
        formatRITMQuery(RITMList){
            let sys_parm = "u_supplier_central_ritmLIKE";
            let result = RITMList.map((RITM) => {return sys_parm + RITM}).join('^OR')
            return result;
        },
        getOnBoardingStatusFor(caseNumber) {
            this.updateSupplierSetupStatus(caseNumber)
            let ritmObj = this.onBoardingCompletedRequests.find(ritm => ritm.caseNumber === caseNumber)
            let onBoardingStatusObj = this.supplierOnBoardingStatus.find(ritm => ritm.caseNumber === caseNumber)
            return onBoardingStatusObj ? onBoardingStatusObj.status : this.getSupplierSetupStatus(ritmObj);
        },
        updateSupplierSetupStatus(caseNumber){
            let ritmObj = this.onBoardingCompletedRequests.find(ritm => ritm.caseNumber === caseNumber)
            let requestObj = this.supplierOnBoardingStatus.find(ritm => ritm.caseNumber === caseNumber)
            if (requestObj && requestObj.vendorId === ""){
                requestObj.status = this.getSupplierSetupStatus(ritmObj);
            }
        },
        getSupplierSetupStatus(ritmObj){
            if (!this.checkForFormQuestions(ritmObj)){
                return this.ONBOARDING_STATUS_MAP.INVITE_SENT
            }
        },
        getVendorIdFor(caseNumber) {
            let onBoardingStatusObj = this.supplierOnBoardingStatus.find(ritm => ritm.caseNumber === caseNumber)
            if(this.getOnBoardingStatusFor(caseNumber) === this.ONBOARDING_STATUS_MAP.INVITE_SENT) return ''
            return onBoardingStatusObj && onBoardingStatusObj.vendorId ? onBoardingStatusObj.vendorId : ''
        },
        ifApexStatusInValid(status){
            return status && status.length > 0;
        },
        checkForFormQuestions(caseDetails){
            if (caseDetails.technologyFromReseller === 'yes'){
                return this.ONBOARDING_STATUS_MAP.NA_RESELLER
            }else if (parseFloat(caseDetails.approximateSpend) <= 0) {
                return this.ONBOARDING_STATUS_MAP.NA_ZERO_DOLLAR_ENGAGEMENT
            }else if (caseDetails.corporateCardPayment === 'yes') {
                return this.ONBOARDING_STATUS_MAP.NA_PAYMENT_CORPORATE_CARD
            }else return null;
        },
        getSupplierSetupStatusIfApexBlank(caseNumber) {
            let ritmObj = this.onBoardingPendingRequests.find(ritm => ritm.caseNumber === caseNumber)
            if (this.checkForFormQuestions(ritmObj)) return this.checkForFormQuestions(ritmObj)
            if (!this.checkForFormQuestions(ritmObj)){
                if (ritmObj && ritmObj.existingSupplier) {
                    return this.ONBOARDING_STATUS_MAP.EXISTING_SUPPLIER
                } else if (ritmObj && ritmObj.inviteSent) {
                    // check to see if this holds true
                    return this.ONBOARDING_STATUS_MAP.INVITE_SENT
                }else{
                    return this.ONBOARDING_STATUS_MAP.NOT_APPLICABLE
                }
            }
        }
    }
}